import React from 'react';
import './DoctorName.css';

const DoctorName = ({ className = "" }) => {
  return (
    <div className={`doctor-logo-text ${className}`}>
      <span className="light-part">Op. Dr. </span>
      <span className="bold-part">Mahmut</span>
      <span className="light-part"> Aluç</span>
    </div>
  );
};

export default DoctorName;